import { Header } from "../../../components/header/Header"
import { CardsWrapper, ConstructionStatusWrapper, Image } from "./styles"
import Img1 from './img/1.jpeg'
import Img2 from './img/2.jpeg'
import Img3 from './img/3.jpeg'
import Img4 from './img/4.jpeg'
import Img5 from './img/5.jpeg'
import Img6 from './img/6.jpg'
import Img7 from './img/7.jpg'
import Img8 from './img/8.jpg'
import Img9 from './img/9.jpg'
import Img10 from './img/10.jpg'
import Img11 from './img/11.jpg'
import Img12 from './img/12.jpg'

export const ConstructionStatus = () => {

    const images = [Img1, Img2, Img3, Img4, Img5, Img6, Img7, Img8, Img9, Img10, Img11, Img12]

    return (
        <ConstructionStatusWrapper>
            <Header>Celeste Mall & Multiplex - Construction Status</Header>
            <CardsWrapper>
                {
                    images.map((item, idx) => (
                        <Image key={idx} src={item} alt={'image-' + idx} />
                    ))
                }
                {/* <iframe 
                    title='celeste video'
                    src="https://drive.google.com/file/d/1sfyAegPOLWC25HKaBUvqZmmLg3H1vXeZ/preview"
                    name="myiFrame"
                    width="400px"
                    height='600px'                    
                    scrolling="no"
                    marginwidth="0"
                    marginheight="0"
                    style={{border:'1px solid ##000000'}}
                    allowfullscreen
                    >
                </iframe> */}
                {/* <div style={{overflow:'auto',position:'absolute',height:0,width:0}}>
                    <a href='https://www.poper.ai/tools/iframe-generator/'>iFrame Generator</a>
                </div> */}
            </CardsWrapper>
        </ConstructionStatusWrapper>
    )
}